import React from 'react';
import PropTypes from 'prop-types';
import y from 'y4/Utils';

const HtmlPanel = ({ panel }) => {
  const html = y.gpv(panel, 'option.html');
  const ias = y.gpv(panel, 'option.innerAttributes');
  return (
    <div
      {...ias}
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  );
};

HtmlPanel.propTypes = {
  panel: PropTypes.object
};

export default HtmlPanel;
